import { Component, OnInit } from '@angular/core';
import { BlockSearchResultsAllComponent } from '@gallaghercp/core-frontend';
import { filter } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'core-block-search-results-page',
    templateUrl: './coro-search-results-page.component.html',
    styleUrl: './coro-search-results-page.component.scss',
    standalone: false,
})
export class CoroSearchResultsPageComponent
    extends BlockSearchResultsAllComponent
    implements OnInit
{
    documentResults: any[] = [];
    pageResults: any[] = [];

    override ngOnInit() {
        //copy ngOnInit from BlockSearchResultsAllComponent and modify the logic needed to sort the results into the two arrays of pages and documents
        this.results = [];
        this.isLoading = false;
        // Check if the user is typing in the search bar to show the search results modal
        this.subscriptions.push(
            this.search.searchBarInput$.subscribe((data) => {
                this.isSearching = data;
            }),
        );

        this.subscriptions.push(
            this.search.results$
                .pipe(
                    switchMap((results: any) => {
                        this.isLoading = true;
                        this.subscriptions.push(
                            this.search.loadingIcon$.subscribe((data) => {
                                this.isSearchModalLoading = data;
                            }),
                        );
                        this.search.isSearchModalLoading(true);
                        if (!this.search.showClearButton) {
                            this.results = [];
                            this.offset = 0;
                        }
                        return results.pipe(
                            map((results: any) => {
                                this.isLoading = false;
                                this.search.isSearchModalLoading(false);
                                this.results = [
                                    ...this.results,
                                    ...results,
                                ] as any;
                                this.total = this.search.totalResults ?? 0;
                                // sort results into documents and pages for results containers
                                this.documentResults = this.results.filter(
                                    (result: any) => result.isDownload,
                                );
                                this.pageResults = this.results.filter(
                                    (result: any) => !result.isDownload,
                                );
                                // console.log(this.documentResults, 'documents');
                                // console.log(this.pageResults, 'pageResults');

                                return results;
                            }),
                        );
                    }),
                )
                .subscribe(),
        );

        if (this.search.faqsEnabled) {
            this.subscriptions.push(
                this.search.query$.subscribe(() => {
                    if (this.search.getQuery() !== null) {
                        this.results = [];
                        this.faq$ = this.cache
                            .postThroughCache('faq', {
                                message: this.search.getQuery(),
                            })
                            .pipe(filter((response: any) => response.resource));
                    }
                }),
            );
        }

        if (this.block) {
            this.introText = this.block.data.introText ?? null;
            this.noResultsText =
                this.block.data.noResultsText ||
                'No results found, please try searching again';
            this.emptySearchText =
                this.block.data.emptySearchText || 'Please enter a search term';
            this.loadMoreText = this.block.data.loadMoreText || 'Load more';
            super.ngOnInit();
        }
    }

    override navigateToSearchResultsLink(result: any) {
        super.navigateToSearchResultsLink(
            result.isDownload ? 'document' : 'content',
            result,
        );
    }

    hasDocuments(): boolean {
        return this.documentResults.length > 0;
    }

    hasPages(): boolean {
        return this.pageResults.length > 0;
    }
}
